import i18n from 'i18n-js';

import CountUpLolWorldsImage from '../../assets/countup/countup-lolworlds.png';
import CountUpLolWorldsSimpleImage from '../../assets/countup/countup-lolworldssimple.png';
import CountUpNewWorldImage from '../../assets/countup/countup-newworld.png';
import C from '../constants';

const { PHOTOAI } = C.AFILIATES;

export const COUNT_UP_TEMPLATES_TITLES = {
  COUNT_UP_BATTERY: 'countup-battery',
  COUNT_UP_BOMB: 'countup-bomb',
  COUNT_UP_CHRISTMASBALL: 'countup-christmasball',
  COUNT_UP_CHRISTMASHAT: 'countup-christmashat',
  COUNT_UP_CHRISTMASPRESENT: 'countup-christmaspresent',
  COUNT_UP_DIGITAL: 'countup-digital',
  COUNT_UP_GENSHIN: 'countup-genshin',
  COUNT_UP_GENSHINSIMPLE: 'countup-genshinsimple',
  COUNT_UP_HALLOWEEN: 'countup-halloween',
  COUNT_UP_LOLWORLDS: 'countup-lolworlds',
  COUNT_UP_LOLWORLDSSIMPLE: 'countup-lolworldssimple',
  COUNT_UP_MINECRAFT: 'countup-minecraft',
  COUNT_UP_NEWWORLD: 'countup-newworld',
  COUNT_UP_SIMPLE: 'countup-simple',
  COUNT_UP_THEGREFG: 'countup-thegrefg',
  COUNT_UP_WITHOUTBACKGROUND: 'countup-withoutbackground',
};

export const COUNT_UP_TEMPLATES_IMAGES = {
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_BATTERY]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-battery-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_BOMB]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-bomb-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_CHRISTMASBALL]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmasball-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_CHRISTMASHAT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmashat-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_CHRISTMASPRESENT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmaspresent-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_DIGITAL]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-digital-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_GENSHIN]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshin-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_GENSHINSIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshinsimple-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_HALLOWEEN]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-halloween-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_LOLWORLDS]: CountUpLolWorldsImage,
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_LOLWORLDSSIMPLE]:
    CountUpLolWorldsSimpleImage,
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_MINECRAFT]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-minecraft-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_NEWWORLD]: CountUpNewWorldImage,
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-simple-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_THEGREFG]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-thegrefg-1.webp',
  [COUNT_UP_TEMPLATES_TITLES.COUNT_UP_WITHOUTBACKGROUND]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countup-withoutbackground-1.webp',
};

export const COUNT_UP_TEMPLATES = {
  countup: [
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t(
        'screens.templates.countup.withoutbackground.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countup.withoutbackground.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_WITHOUTBACKGROUND,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-withoutbackground-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-withoutbackground-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-withoutbackground-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-withoutbackground-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.withoutbackground.title'),
      tier: 'pro',
      users: 4404,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.digital.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.digital.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_DIGITAL,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-digital-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-digital-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-digital-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-digital-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.digital.title'),
      tier: 'pro',
      users: 2146,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.minecraft.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.minecraft.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_MINECRAFT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-minecraft-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-minecraft-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-minecraft-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-minecraft-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.minecraft.title'),
      tier: 'pro',
      users: 818,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.genshin.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.genshin.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_GENSHIN,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshin-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshin-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshin-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshin-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.genshin.title'),
      tier: 'pro',
      users: 20,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t(
        'screens.templates.countup.christmaspresent.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countup.christmaspresent.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_CHRISTMASPRESENT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmaspresent-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmaspresent-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmaspresent-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmaspresent-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.christmaspresent.title'),
      tier: 'pro',
      users: 102,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.battery.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.battery.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_BATTERY,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-battery-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-battery-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-battery-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-battery-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.battery.title'),
      tier: 'pro',
      users: 70,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.thegrefg.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.thegrefg.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_THEGREFG,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-thegrefg-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-thegrefg-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-thegrefg-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-thegrefg-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.thegrefg.title'),
      tier: 'pro',
      users: 3472,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t(
        'screens.templates.countup.genshinsimple.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countup.genshinsimple.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_GENSHINSIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshinsimple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshinsimple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshinsimple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-genshinsimple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.genshinsimple.title'),
      tier: 'pro',
      users: 214,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t(
        'screens.templates.countup.christmasball.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.countup.christmasball.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_CHRISTMASBALL,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmasball-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmasball-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmasball-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmasball-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.christmasball.title'),
      tier: 'pro',
      users: 10,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.halloween.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.halloween.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_HALLOWEEN,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-halloween-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-halloween-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-halloween-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-halloween-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.halloween.title'),
      tier: 'pro',
      users: 60,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.christmashat.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.christmashat.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_CHRISTMASHAT,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmashat-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmashat-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmashat-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-christmashat-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.christmashat.title'),
      tier: 'pro',
      users: 109,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.simple.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.simple.title'),
      tier: 'basic',
      users: 196,
    },
    {
      category: i18n.t('screens.templates.countup.title'),
      description: i18n.t('screens.templates.countup.bomb.description'),
      shortDescription: i18n.t(
        'screens.templates.countup.bomb.shortDescription'
      ),
      id: COUNT_UP_TEMPLATES_TITLES.COUNT_UP_BOMB,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-bomb-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-bomb-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-bomb-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countup-bomb-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.countup.bomb.title'),
      tier: 'pro',
      users: 59,
    },
  ],
};

export default {
  COUNT_UP_TEMPLATES,
  COUNT_UP_TEMPLATES_IMAGES,
  COUNT_UP_TEMPLATES_TITLES,
};
